"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _flatten = _interopRequireDefault(require("lodash/fp/flatten"));
var _isEmpty = _interopRequireDefault(require("lodash/fp/isEmpty"));
var _prop = _interopRequireDefault(require("lodash/fp/prop"));
var _has = _interopRequireDefault(require("lodash/fp/has"));
var _omit = _interopRequireDefault(require("lodash/fp/omit"));
var _Form = require("../Form");
var _FormGroup = require("../FormGroup");
var _FormFieldPresentation = _interopRequireDefault(require("./FormFieldPresentation"));
var _utils = require("../Form/utils");
var _excluded = ["as", "name", "subscribe"],
  _excluded2 = ["name"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var FormField = function FormField(_ref) {
  var as = _ref.as,
    propName = _ref.name,
    _ref$subscribe = _ref.subscribe,
    subscribe = _ref$subscribe === void 0 ? [] : _ref$subscribe,
    presenterProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useContext = (0, _react.useContext)(_Form.Context),
    _useContext$form = _useContext.form,
    _useContext$form2 = _useContext$form === void 0 ? {} : _useContext$form,
    errors = _useContext$form2.errors,
    getFieldProps = _useContext$form2.getFieldProps,
    setFieldValue = _useContext$form2.setFieldValue,
    setFieldTouched = _useContext$form2.setFieldTouched,
    registerField = _useContext$form2.registerField,
    touched = _useContext$form2.touched,
    unregisterField = _useContext$form2.unregisterField,
    values = _useContext$form2.values,
    validateField = _useContext$form2.validateField,
    trimInput = _useContext$form2.trimInput;
  var _useContext2 = (0, _react.useContext)(_FormGroup.formGroupContext),
    ctxName = _useContext2.name,
    formGroupCtx = (0, _objectWithoutProperties2["default"])(_useContext2, _excluded2);
  var name = propName !== null && propName !== void 0 ? propName : ctxName;
  var subscription = subscribe.map(function (field) {
    return [field, [(0, _prop["default"])('value')(getFieldProps === null || getFieldProps === void 0 ? void 0 : getFieldProps(field)), (0, _prop["default"])(field)(errors), (0, _prop["default"])(field)(touched)]];
  });
  var subscribedFields = (0, _react.useMemo)(function () {
    return !(0, _isEmpty["default"])(subscription) ? subscription.reduce(function (fields, _ref2) {
      var _ref3 = (0, _slicedToArray2["default"])(_ref2, 2),
        field = _ref3[0],
        status = _ref3[1];
      return _objectSpread(_objectSpread({}, fields), {}, (0, _defineProperty2["default"])({}, field, {
        value: (0, _utils.trimOnNeeds)(status[0], trimInput),
        error: status[1],
        touched: status[2]
      }));
    }, {}) : undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, (0, _compose["default"])(_flatten["default"], _flatten["default"])(subscription));
  return /*#__PURE__*/_react["default"].createElement(_FormFieldPresentation["default"], (0, _extends2["default"])({
    as: as,
    name: name,
    trimInput: trimInput,
    error: (0, _prop["default"])(name)(errors),
    value: (0, _prop["default"])('value')(getFieldProps === null || getFieldProps === void 0 ? void 0 : getFieldProps(name)),
    touched: (0, _prop["default"])(name)(touched),
    hasValue: (0, _has["default"])(name)(values),
    registerField: registerField,
    setFieldValue: setFieldValue,
    setFieldTouched: setFieldTouched,
    unregisterField: unregisterField,
    subscribedFields: subscribedFields,
    validateField: validateField
  }, (0, _omit["default"])(['labelText', 'setLabelText'])(formGroupCtx), presenterProps));
};
var _default = exports["default"] = FormField;